import type { ReactNode } from 'react';

export const symbol_speed_3: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M519-323q32-15 43-48.5t-9-62.5q-48-64-97-129.5T359-695q-8-10-19-4.5t-8 17.5l38 158q19 79 39 157 8 35 41.5 48t68.5-4ZM192-160q-17.5 0-33.75-8.5T133-193q-27.48-46.91-40.24-99.43Q80-344.95 80-399q0-90 35.5-166.5T213-697q9-8 21.5-7t20.5 11.5q8 10.5 6 23T250-649q-51 47-80.5 111T140-399q0 48 11.5 93t36.5 86h584q24-41 36-86t12-93q0-79.84-34.14-147.97T695-663q-54-45-123-64.5T433-736q-12 2-21.5-5T399-760q-3-12 2.5-22.5T418-795q85-14 168 8.5T735-708q66 56 105.5 135.31Q880-493.37 880-399q0 54-14 106t-40 100q-9 16-24.5 24.5T768-160H192Zm292-234Z"
		/>
	</svg>
);
